import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getPredictorSlice = createSlice({
    name: 'predictor',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchPredictor.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchPredictor.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchPredictor.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setAds, setStatus } = getPredictorSlice.actions;
export default getPredictorSlice.reducer;

export const fetchPredictor = createAsyncThunk('/predictor/fetch', async ({ id }) => {
    const res = await axios.get(`${getBaseUrl()}/RacePredictor/${id}`);
    const adsData = res.data;
    return adsData.data;
})